// Mock data for Fixed Group - will be replaced by backend integration for contact form

export const COMPANY = {
  name: 'Fixed Group',
  tagline: 'Precision. Reliability. Cold Chain Excellence.',
  established: 1999,
  parent: 'Fixed Borneo Reefer Services Sdn. Bhd. (FBRSSB)',
  website: 'www.fixedgroup.com',
  overview:
    'Fixed Group is a Malaysian conglomerate specializing in refrigerated container services, cold-chain logistics, and cold room solutions. With more than two decades of hands-on experience, we support shipping lines, logistics hubs, and cold storage industries across Southeast Asia.',
  vision:
    'To be the leading and most innovative provider of reefer container and cold room services in Southeast Asia, delivering excellence in refrigerated logistics through advanced technology, reliability, and customer-focused solutions.',
  mission: [
    'Provide high-quality, efficient, and reliable services in reefer container repair, leasing, and cold room solutions.',
    'Ensure operational excellence by integrating cutting-edge technologies like the Roaming Reefer Monitoring System (RRMS) to enhance monitoring accuracy and reduce downtime.',
    'Build long-term relationships with clients through responsive technical support, cost-effective services, and continuous improvement.'
  ],
  goals: [
    'Enhance customer satisfaction with consistent, dependable service in refrigerated logistics.',
    'Embrace technological innovation through RRMS and smart monitoring systems.',
    'Expand market reach within Malaysia and across the Southeast Asia region.',
    'Sustain operational excellence via workforce training, quality control, and process optimization.',
    'Support environmental responsibility through sustainable reefer maintenance practices.'
  ],
  stats: [
    { value: '25+', label: 'Years of Experience' },
    { value: '3', label: 'Business Divisions' },
    { value: '700+', label: 'Reefer Units Monitored' },
    { value: '2', label: 'Branches in Malaysia' }
  ]
};

export const BRANCHES = [
  {
    id: 'hq',
    name: 'Main HQ — Klang, Selangor',
    address: '39, Jalan Resak 2/KS7, Bandar Botanic, Klang, Selangor D.E, 41200',
    map: 'https://maps.app.goo.gl/MuKF9UM3Lvc7eFBv9'
  },
  {
    id: 'sabah',
    name: 'Sabah Branch — Kota Kinabalu',
    address: '1A/08 Lot 8, Ground Floor, Lorong Alam Puteri 1, Alam Puteri Shoplots, 88450 Kota Kinabalu',
    map: 'https://maps.app.goo.gl/kpiVegyQAFBLFJzz9'
  }
];

export const CONTACT = {
  phone: '+60 16-205 9532',
  phones: [
    { display: '+6016-205 9532', tel: '+60162059532' },
    { display: '+6012-913 0786', tel: '+60129130786' },
    { display: '+6019-373 5298', tel: '+60193735298' }
  ],
  email: 'bash@fixedlogistic.com',
  hours: 'Mon – Sat, 8:30 AM – 6:00 PM (MYT)'
};

export const CORE_VALUES = [
  { title: 'Customer First', desc: 'We put clients at the centre of every decision, delivering service tailored to their operations.' },
  { title: 'Quality Delivery', desc: 'Rigorous standards and skilled technicians ensure containers and cold rooms always perform.' },
  { title: 'Integrity & Accountability', desc: 'Transparent pricing, honest reporting, and ownership of every job we take on.' },
  { title: 'Innovation', desc: 'Pioneering RRMS remote monitoring and smart electronics for the modern cold chain.' }
];

export const WHY_US = [
  { title: 'Two Decades of Expertise', desc: 'Hands-on reefer and cold room experience since 1999.' },
  { title: '24/7 Response Team', desc: 'Round-the-clock technicians and emergency support across Malaysia.' },
  { title: 'Cost-Effective Solutions', desc: 'Out-of-the-box ideas that reduce downtime and total cost.' },
  { title: 'Cutting-Edge Technology', desc: 'RRMS monitoring, GPS-tracked fleet and precision servicing.' },
  { title: 'OEM-Trained Technicians', desc: 'Carrier, Star Cool, Thermoking and Daikin certified handling.' },
  { title: 'End-to-End Coverage', desc: 'Repair, leasing, transport and cold room construction under one roof.' }
];

export const DIVISIONS = [
  {
    slug: 'fixed-borneo-reefer',
    short: 'FBRSSB',
    name: 'Fixed Borneo Reefer Services Sdn. Bhd.',
    established: 1999,
    tagline: 'Reefer container repair, PTI and cold room specialists.',
    image: 'https://images.unsplash.com/photo-1617938568125-b55e59775632?crop=entropy&cs=srgb&fm=jpg&q=85',
    summary:
      'FBRSSB is the flagship arm of Fixed Group, established in 1999 to provide specialized services in reefer container handling and cold room solutions. From Pre-Trip Inspections and refurbishment to RRMS monitoring and cold room construction, FBRSSB supports shipping lines and cold storage industries across Malaysia.',
    services: [
      'Pre-Trip Inspections (PTI)',
      'Reefer container repair',
      'Reefer container refurbishment',
      'Buy and sale of reefer containers and parts',
      'Servicing reefer containers and machinery',
      'Reefer container leasing',
      'Outdoor and on-site repairs',
      'Cannibalisation of reefer parts for repair',
      'Reefer container survey',
      'Physical damage repairs',
      'Cold room servicing',
      'Cold room building',
      'Technical support for cold rooms & reefers'
    ]
  },
  {
    slug: 'fixed-logistic-services',
    short: 'FLS',
    name: 'Fixed Logistic Sdn.Bhd.',
    established: 2009,
    tagline: 'Cold-chain trucking and reefer container haulage across Malaysia.',
    image: 'https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&q=85',
    summary:
      'Fixed Logistic Sdn.Bhd. (FLS) was formed in 2009 to focus on cold-chain container and cargo trucking across the Malaysian region. FLS operates GPS-tracked prime movers with gen-set fitted trailers, ensuring temperature integrity from port to destination.',
    services: [
      'Cold chain refrigerated container haulage',
      'Prime mover and trailer transportation',
      'GPS real-time fleet monitoring',
      'Gen-set fitted trailers for reefer cargo',
      'Port pickup and last-mile delivery',
      'Dedicated Emergency Respond Team (ERT)',
      '24/7 breakdown and accident support'
    ],
    fleet: {
      primeMovers: ['BHH 1369', 'BHP 3046'],
      chassis: ['TB/A 8717', 'TB/A 9346', 'TB/B 6764', 'TB/B 7878']
    }
  },
  {
    slug: 'fixed-chiller-freezer',
    short: 'FCFS',
    name: 'Fixed Chiller and Freezer Services',
    established: 1999,
    tagline: 'Reefer PTI, repair and RRMS smart monitoring.',
    image: 'https://images.pexels.com/photos/14020705/pexels-photo-14020705.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    summary:
      'Fixed Chiller and Freezer Services (FCFS) is the trusted PTI and repair partner for major shipping lines including OOCL, Hapag-Lloyd, PIL, YML, Wan Hai, MOL, Maersk and COSCO. FCFS also pioneered the Roaming Reefer Monitoring System (RRMS) for high-tech terminal monitoring.',
    services: [
      'Pre-Trip Inspections (PTI) at Port Klang depots',
      'Cable splicing and power plug replacement',
      'Evaporator and condenser fan repairs',
      'Sensor repairs and refrigerant charge',
      'Machinery parts repair',
      'Cold room light and structural (interior foaming) repairs',
      'RRMS — Roaming Reefer Monitoring System'
    ]
  }
];

export const SERVICES = [
  { title: 'Pre-Trip Inspection (PTI)', desc: 'Full inspection of cooling, electrical and structural systems before every trip.', image: 'https://images.unsplash.com/photo-1619679610144-0d5d42196d57?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { title: 'Reefer Container Repair', desc: 'Skilled technicians fix electrical faults, leaks and broken components on-site or at depot.', image: 'https://images.pexels.com/photos/30748602/pexels-photo-30748602.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { title: 'Refurbishment', desc: 'Extend container life with structural work, insulation, repainting and component upgrades.', image: 'https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { title: 'Reefer Leasing', desc: 'Short- and long-term rental of reefer containers without ownership investment.', image: 'https://images.pexels.com/photos/14020705/pexels-photo-14020705.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { title: 'Cold Chain Logistics', desc: 'GPS-tracked prime movers with gen-set trailers for temperature-controlled cargo.', image: 'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { title: 'Cold Room Construction', desc: 'Custom cold rooms designed and installed for warehouses and food processors.', image: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { title: 'RRMS Monitoring', desc: 'Roaming Reefer Monitoring System for real-time terminal reefer monitoring.', image: 'https://images.pexels.com/photos/38812162/pexels-photo-38812162.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { title: 'Technical Support', desc: 'Expert troubleshooting for reefers and cold rooms, on-call, 24/7.', image: 'https://images.pexels.com/photos/37186960/pexels-photo-37186960.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' }
];

export const TEAM = [
  { name: 'Baskaren A/L Chinniah', role: 'Founder & CEO', initials: 'BC' },
  { name: 'Pushpamary A/P Barry', role: 'Senior Clerk', initials: 'PB' },
  { name: 'Sri Ragu Ram A/L Raman', role: 'Technical Manager', initials: 'SR' },
  { name: 'Sarveesh A/L Baskaren', role: 'Reefer Technician', initials: 'SB' },
  { name: 'Parhvein Prasad', role: 'Reefer Technician / IT Support', initials: 'PP' },
  { name: 'Uthaiya Chandar', role: 'Reefer Technician', initials: 'UC' },
  { name: 'Darshan A/L Arasan', role: 'Reefer Technician', initials: 'DA' }
];

export const SHIPPING_PARTNERS = [
  { name: 'Maersk', logo: '/logos/maersk.png' },
  { name: 'Hapag-Lloyd', logo: '/logos/hapag-lloyd.png' },
  { name: 'OOCL', logo: '/logos/oocl.png' },
  { name: 'COSCO', logo: '/logos/cosco.png' },
  { name: 'PIL', logo: '/logos/pil.png' },
  { name: 'Yang Ming', logo: '/logos/yang-ming.png' },
  { name: 'Wan Hai', logo: '/logos/wan-hai.png' },
  { name: 'MOL', logo: '/logos/mol.png' },
  { name: 'UASC', logo: '/logos/uasc.png' },
  { name: 'Goodrich', logo: '/logos/goodrich.png' }
];

export const OEM_PARTNERS = [
  { name: 'Carrier', logo: '/logos/carrier.png' },
  { name: 'Thermo King', logo: '/logos/thermoking.png' },
  { name: 'Daikin', logo: '/logos/daikin.png' },
  { name: 'Star Cool', logo: null }
];

export const GALLERY = [
  { category: 'Reefer Repairs', title: 'Our technicians servicing a Carrier reefer unit', image: '/gallery/real-5.jpg' },
  { category: 'Reefer Repairs', title: 'On-site reefer machinery repair', image: '/gallery/real-3.jpg' },
  { category: 'Reefer Repairs', title: 'Fixed team servicing reefers between stacks', image: '/gallery/real-7.jpg' },
  { category: 'Reefer Repairs', title: 'Refrigerant charging & vacuum service', image: '/gallery/real-8.jpg' },
  { category: 'Reefer Repairs', title: 'Reefer controller & humidity sensor inspection', image: '/gallery/real-4.jpg' },
  { category: 'Fleet & Logistics', title: 'Fixed container leasing — branded unit', image: '/gallery/real-2.jpg' },
  { category: 'Port & Terminal', title: 'Fixed team — tank reefer genset inspection', image: '/gallery/real-1.jpg' },
  { category: 'Port & Terminal', title: 'Reefer units lined up at the depot', image: '/gallery/real-6.jpg' },
  { category: 'Port & Terminal', title: 'Tank reefer maintenance on trailer', image: '/gallery/real-9.jpg' },
  { category: 'Port & Terminal', title: 'Working at height — tank reefer service', image: '/gallery/real-10.jpg' },
  { category: 'Reefer Repairs', title: 'Reefer container servicing', image: 'https://images.unsplash.com/photo-1617938568125-b55e59775632?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { category: 'Reefer Repairs', title: 'Pre-Trip Inspection at depot', image: 'https://images.unsplash.com/photo-1619679610144-0d5d42196d57?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { category: 'Reefer Repairs', title: 'Container refurbishment works', image: 'https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { category: 'Reefer Repairs', title: 'On-site repair operations', image: 'https://images.pexels.com/photos/30748602/pexels-photo-30748602.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { category: 'Fleet & Logistics', title: 'GPS-tracked prime mover', image: 'https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { category: 'Fleet & Logistics', title: 'Cold chain haulage on the highway', image: 'https://images.unsplash.com/photo-1695222833131-54ee679ae8e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxkZWxpdmVyeSUyMHRydWNrJTIwaGlnaHdheXxlbnwwfHx8fDE3ODcyMzc5NzF8MA&ixlib=rb-4.1.0&q=85' },
  { category: 'Fleet & Logistics', title: 'Refrigerated cargo transport', image: 'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { category: 'Fleet & Logistics', title: 'Container trucking at dusk', image: 'https://images.pexels.com/photos/5410923/pexels-photo-5410923.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { category: 'Cold Rooms', title: 'Cold room construction', image: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { category: 'Cold Rooms', title: 'Cold storage facility', image: 'https://images.pexels.com/photos/5953713/pexels-photo-5953713.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { category: 'Port & Terminal', title: 'Reefer units at Port Klang', image: 'https://images.pexels.com/photos/14020705/pexels-photo-14020705.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { category: 'Port & Terminal', title: 'Stacked containers at terminal', image: 'https://images.unsplash.com/photo-1678182451047-196f22a4143e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxzaGlwcGluZyUyMGNhcmdvJTIwY29udGFpbmVycyUyMHBvcnR8ZW58MHx8fHwxNzg3MjM3OTcxfDA&ixlib=rb-4.1.0&q=85' },
  { category: 'Port & Terminal', title: 'Container vessels at anchor', image: 'https://images.pexels.com/photos/15346128/pexels-photo-15346128.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { category: 'Port & Terminal', title: 'RRMS terminal monitoring', image: 'https://images.pexels.com/photos/38812162/pexels-photo-38812162.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { category: 'Reefer Repairs', title: '24/7 technical support', image: 'https://images.pexels.com/photos/37186960/pexels-photo-37186960.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' }
];

export const HERO_IMAGE = 'https://images.unsplash.com/photo-1617938568125-b55e59775632?crop=entropy&cs=srgb&fm=jpg&q=85';
